import { TABOO_INSTANCE_FILTER_RESET } from "app/games/taboo/reducers/currentUserFilterPerInstance";

export default function resetFilter(instanceId) {
  return {
    type: TABOO_INSTANCE_FILTER_RESET,
    payload: { instanceId },
  }
}
